import * as React from 'react';
import { verify } from '../api/api';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { StatusRegistration } from '../features/verify';

const Verify = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [res, setRes] = React.useState({});
  const [progress, setProgress] = React.useState(true);

  React.useEffect(() => {
    const ticket = searchParams.get('ticket');
    verify(ticket, setRes, setProgress);
  }, []);

  const goTo = async () => {
    navigate('/');
  };

  return <StatusRegistration progress={progress} status={res.status} userLoggedIn={true} confirmHandler={goTo} />;
};

export default Verify;
